import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import StudentPage from '../../views/StudentPage';
const GLOBAL = require('../../Globals');

class Attendance extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			cls: '',
			section: '',
			atype: '',
			attdate: moment(),
			_message: '',
			alertClass: '',
			posts: [],
			stud: [],
			data: [],
			accyear: [],
			_redirect: false,
			chk: '',
			att: [],
			remark: [],
			postFilter: [],
			sections: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
	}

	/** redirect to Attendance view **/
	onBack(e) {

		this.setState({ _redirect: true });
	}

	onRemarkChange(id, e) {

		var index = this.state.att.findIndex(function (obj) {
			return (obj.id == id);
		});

		if (index != -1) {

			this.state.att[index].remarks = e.target.value;

		}

	}

	checkChange(id, e) {

		if (e.target.checked) {
			var index = this.state.att.findIndex(function (obj) {
				// var obj=JSON.parse(objstr);
				return (obj.id == id);
			});

			if (index === -1) {
				this.state.att.push({ "id": id, "remarks": 0 });
			}

		}
		else {

			for (var i = 0; i < this.state.att.length; i++) {

				// var obj=JSON.parse(this.state.att[i]);

				if ((this.state.att[i].id == id)) {

					this.state.att.splice(i, 1);
					break;
				}
			}
		}
	}

	/** set value to Attendance datepicker **/
	handleChange(date) {
		this.setState({
			attdate: date
		});
	}

	onSecChange(e) {

		this.state.section = e.target.value;
		this.filterdata();
	}

	onClassChange(e) {

		this.state.cls = e.target.value;
		this.setState({ cls: e.target.value });
		$()
		this.getsection();
		this.filterdata();
	}
	getsection() {
		var ar = $("#year").val();
		$("#showLoader").show();
		GetData('section/getsecbyclass/' + ar + '/' + this.state.cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}
	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.filterdata();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		this.data = {
			acyear: this.state.acyear,
			cls: this.state.cls,
			section: this.state.section,
			attdate: this.state.attdate,
			atype: this.state.atype,
			att: this.state.att,
		}
		PostData('student/attendance', this.data).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				alert('Attendance Added Successfully!..');
				this.state.att = [];
				$("#attab").hide();
				$(".abcheck").prop("checked", false);
			}
			else {

				this.setState({
					_message: 'Error!..',
					alertClass: 'alert alert-danger',
				});
			}
		});
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getclass();
		this.getacyear();
		this.filterdata();
	}

	/** get Class **/
	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** Get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getclass();
				this.getstudent();
				this.filterdata();
			}
		});
	}

	/** get Student **/
	getstudent() {
		this.setState({ stud: [] });
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getstdbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					stud: responseJson,
					postFilter: responseJson
				});
			}
		});
	}

	filterdata() {

		this.state.postFilter = [];
		var dat = [];
		for (var i = 0; i < this.state.stud.length; i++) {

			if (this.state.cls != '' && this.state.section != '') {

				if (this.state.stud[i].class == this.state.cls && this.state.stud[i].section == this.state.section) {

					dat.push(this.state.stud[i]);
				}
			}

		}
		this.setState({ postFilter: dat });
	}

	render() {

		/** disable weekend(sunday) in react-datepicker **/
		var isWeekday = (date) => {
			const day = date.day()
			return day !== 0 && day !== 7
		}

		if (this.state._redirect) {

			return (<Redirect to='/student/attendanceview' />);
		}

		/** set status select box **/
		this.attype = [
			{ value: '', name: 'Select' },
			{ value: 'regular', name: 'Regular' },
			{ value: 'morning', name: 'Morning' }
		];

		var items = this.state.posts;
		var sub = this.state.subj;
		var tea = this.state.teach;
		var acyear = this.state.accyear;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '') {

			$("#attab").show();

		}
		else {

			$("#attab").hide();
		}


		$('.selectall').click(function () {
			if ($(this).is(':checked')) {
				$('table input').attr('checked', true);
			} else {
				$('table input').attr('checked', false);
			}
		});

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="attform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Attendance</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
										<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
										<span className="pull-right">
											<Button outline color="primary" onClick={this.onBack}>Attendance View</Button>
										</span>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="2">
												<FormGroup>
													<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
													<select name="cls" onChange={this.onClassChange} className="form-control" id="clas" required>
														<option value="">Select Class</option>
														{
															items.map(function (item) {
																return <option value={item.id}>{item.class}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
													<select name="section" onChange={this.onSecChange} className="form-control" id="secs" required>
														<option value="">Select Section</option>
														{this.state.sections.map(function (item) {
															return <option value={item.id}>{item.secs}</option>;
														})}
													</select>
												</FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<Label htmlFor="name">Date <span className="text-danger">*</span></Label>
													<DatePicker selected={this.state.attdate} id="attendancedate" onChange={this.handleChange} className="form-control" dateFormat="DD-MM-YYYY" filterDate={isWeekday} />
												</FormGroup>
											</Col>
											<Col md="2">
												<FormGroup>
													<Label htmlFor="name">Type <span className="text-danger">*</span></Label>
													<select name="atype" onChange={this.onChange} className="form-control" required>
														{this.attype.map((e, key) => {
															return <option key={key} value={e.value}>{e.name}</option>;
														})}
													</select>
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
							<Col md="12" id="attab">
								<Card>
									<CardHeader className="card-header-inner">
										<strong>Attendance</strong>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<Table responsive bordered striped id="atttable">
													<thead>
														<tr>
															<th>Check Absent</th>
															<th>Reg No</th>
															<th>Student Name</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>
														{this.state.postFilter.map(item =>

															<tr key={item}>
																<td><input type="checkbox" className="abcheck" name="chk_select" onClick={this.checkChange.bind(this, item.regno)} /></td>
																<td>{item.regno}</td>
																<td>{item.stdname}</td>
																<td><input type="text" name="remarks" id={item.id} onChange={this.onRemarkChange.bind(this, item.regno)} /></td>
															</tr>
														)}
													</tbody>
												</Table>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Submit</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default Attendance;


// WEBPACK FOOTER //
// ./src/student/Attendance/Attendance.js